import { AlertColor } from "@mui/material/Alert";

export const SET_ALERT = 'SET_ALERT';
export const SET_ALERT_CONTEXT = 'SET_ALERT_CONTEXT';
export const SET_ALERT_SEVERITY = 'SET_ALERT_SEVERITY';
export const CLEAR_ALERT = 'CLEAR_ALERT';

// Action Interfaces
  interface SetAlertAction {
    type: typeof SET_ALERT;
    payload: boolean
  }
  
  interface SetAlertSeverityAction {
    type: typeof SET_ALERT_SEVERITY;
    payload: AlertColor;
  }
  
  interface SetAlertContextAction {
    type: typeof SET_ALERT_CONTEXT;
    payload: string;
  }
  
  interface ClearAlertAction {
    type: typeof CLEAR_ALERT;
  }
  
  // Union Action Type
  export type AlertActions =
    | SetAlertAction
    | SetAlertSeverityAction
    | SetAlertContextAction
    | ClearAlertAction;


export const setAlert = (alert: boolean): SetAlertAction => ({
    type: SET_ALERT,
    payload: alert,
});

export const setAlertSeverity = (severity: AlertColor) : SetAlertSeverityAction => ({
    type: SET_ALERT_SEVERITY,
    payload: severity,
});

export const setAlertContext = (context:string) : SetAlertContextAction => ({
    type: SET_ALERT_CONTEXT,
    payload: context,
});

export const clearAlert = () : ClearAlertAction => ({
    type: CLEAR_ALERT,
});

export const handleCloseAlert = () => (dispatch:any) => {
    dispatch(clearAlert());
};